import React from 'react';
import styled, { css } from 'styled-components';
import { Classable, HasChildren, Shapeable, Slice } from '@shapeable/types';
import { breakpoints, theme, ColorTokens } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { ContentNode, ImageEntityBackground, SliceLayout, usePageEntity } from '@shapeable/ui';
import { Region } from '@shapeable/kelp-forest-alliance-types';

const cls = classNames('slice-region-key-message');

// -------- Types -------->

// -------- Props -------->

export type SliceRegionKeyMessageProps = Classable & HasChildren & { 
  entity?: Slice;
};

export const SliceRegionKeyMessageDefaultProps: Omit<SliceRegionKeyMessageProps, 'entity'> = {
};

// -------- Child Component Props -------->

type ContainerProps = {

};

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
    display: flex;
    justify-content: center;
    flex-direction: column;
    text-align: center;
  `,
});

const MessageStyles = breakpoints({
  base: css`
    font-size: 2em;
    font-weight: 300;
    line-height: 1.35em;
    font-family: ${theme.FONT('serif')};
    font-style: italic;
    color: ${theme.COLOR('canvas')};
  `,
  tablet: css`
    font-size: 2.25em;
  `,
  desktop: css`
    font-size: 2.5em;
  `,
});


// -------- Components -------->

const My = {
  Container: styled(SliceLayout)<ContainerProps>`${ContainerStyles}`,
    Message: styled(ContentNode)`${MessageStyles}`,
};

export const SliceRegionKeyMessage: Shapeable.FC<SliceRegionKeyMessageProps> = (props) => {
  const { className, children, entity } = props;

  const region = usePageEntity() as Region;
  const { content } = entity || {};

  const { keyMessageImage} = region || {};

  const backgroundImages = keyMessageImage ? [keyMessageImage?.openGraph] : [];

  const regionSlice: Slice = {
    ...entity,
    backgroundImages,
  };
  
  return (
    <My.Container 
      className={cls.name(className)}
      entity={regionSlice} 
      boundary='content'
      verticalPadding='large'
      overlayColor='#00000033'
      >
      {
        content && content.text && 
        <My.Message entity={content} />
      }
    </My.Container>
  )
};

SliceRegionKeyMessage.cls = cls;